var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout_DuelChallenge_Actions',[_c('span',{staticClass:"mr-2 mb-2"},[_vm._v(_vm._s(_vm.$t("duels.challenge-login-prompt")))]),_c('Button_Login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }